export function getValueFromDotOperatorString(obj, key) {
  return key.split('.').reduce((o, i) => o?.[i], obj)
}

function getUpdatedValueFromListOfKeys(obj, keys, value) {
  if (keys.length === 1) {
    return {
      ...obj,
      [keys[0]]: value,
    }
  }

  const key = keys.shift()

  return {
    ...obj,
    [key]: getUpdatedValueFromListOfKeys(obj[key], keys, value),
  }
}

export function setValueFromDotOperatorString(obj, key, value) {
  const objectKeys = key.split('.')
  return getUpdatedValueFromListOfKeys(obj, objectKeys, value)
}
